export const ENTITY_LEVEL = {
  USER: 'user',
};

export const SIDE_NAV_BAR_OPTIONS = {
  USER_MAPPING: 'userMapping',
};

export const COMMUNICATION_CRITERIA = 'all';
export const COMMUNICATION_FIELD_MAPPING_TYPE = 'deduplication';
export const COMMUNICATION_DEDUPLICATION_MAPPING = {
  velarisFieldId: 'email',
  vendorFieldId: 'email',
};
